/**
 * Villy Shop product page: <vs-gallery> (drag, dots, zoom), <vs-ticker> (offer lines), the sticky order bar,
 * the story clamp and links to accordions. Depends on vs-core.js. Safe to load twice.
 */
(function () {
  'use strict';
  if (window.__vsPdpLoaded) return;
  window.__vsPdpLoaded = true;

  var doc = document;
  var VS = function () { return window.VillyShop || {}; };
  var reduce = function () { return !!(VS().reduceMotion && VS().reduceMotion.matches); };
  var ARROW_L = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5m6-6-6 6 6 6"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';

  /* ====================================================================== zoom dialog (one for the page) */
  var zoom = null;
  function ensureZoom() {
    if (zoom) return zoom;
    var dlg = doc.createElement('dialog');
    dlg.className = 'vs-dlg vs-zoom';
    dlg.setAttribute('aria-label', 'Enlarged photo');
    dlg.innerHTML = '<div class="vs-zoom__stage" data-vs-zstage>' +
      '<button type="button" class="vs-icon-btn vs-zoom__x" data-vs-zclose aria-label="Close">' + CLOSE + '</button>' +
      '<button type="button" class="vs-zoom__nav vs-zoom__nav--prev" data-vs-zprev aria-label="Previous photo">' + ARROW_L + '</button>' +
      '<img class="vs-zoom__img" alt="" draggable="false">' +
      '<button type="button" class="vs-zoom__nav vs-zoom__nav--next" data-vs-znext aria-label="Next photo">' + ARROW_R + '</button>' +
      '<p class="vs-zoom__count" aria-live="polite"></p></div>';
    doc.body.appendChild(dlg);
    var img = dlg.querySelector('.vs-zoom__img');
    var count = dlg.querySelector('.vs-zoom__count');
    var z = { dlg: dlg, img: img, list: [], i: 0, zoomed: false, opener: null };
    function show(i) {
      z.i = (i + z.list.length) % z.list.length;
      var item = z.list[z.i];
      img.src = item.src; img.alt = item.alt || '';
      count.textContent = (z.i + 1) + ' / ' + z.list.length;
      reset();
    }
    function reset() { z.zoomed = false; img.classList.remove('is-zoomed'); img.style.transform = ''; img.style.transformOrigin = ''; }
    function origin(e) {
      var r = img.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
      var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
      return x + '% ' + y + '%';
    }
    var down = null;
    img.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, t: Date.now() }; });
    img.addEventListener('pointermove', function (e) { if (z.zoomed) img.style.transformOrigin = origin(e); });
    img.addEventListener('pointerup', function (e) {
      if (!down) return;
      var dx = e.clientX - down.x; var dy = e.clientY - down.y;
      var moved = Math.abs(dx) > 8 || Math.abs(dy) > 8;
      down = null;
      if (moved && !z.zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { show(z.i + (dx < 0 ? 1 : -1)); return; }
      if (moved) return;
      if (z.zoomed) reset();
      else { img.style.transformOrigin = origin(e); img.style.transform = 'scale(2)'; img.classList.add('is-zoomed'); z.zoomed = true; }
    });
    dlg.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-vs-zclose]') || t === dlg.querySelector('[data-vs-zstage]')) VS().closeDialog(dlg);
      else if (t.closest('[data-vs-zprev]')) show(z.i - 1);
      else if (t.closest('[data-vs-znext]')) show(z.i + 1);
    });
    dlg.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(z.i - 1);
      else if (event.key === 'ArrowRight') show(z.i + 1);
    });
    dlg.addEventListener('vs:close', function () { reset(); if (z.opener) z.opener.focus({ preventScroll: true }); });
    z.show = show;
    zoom = z;
    return z;
  }
  function openZoom(list, index, opener) {
    var z = ensureZoom();
    z.list = list; z.opener = opener;
    var multiple = list.length > 1;
    z.dlg.querySelector('[data-vs-zprev]').hidden = !multiple;
    z.dlg.querySelector('[data-vs-znext]').hidden = !multiple;
    z.show(index);
    VS().openDialog(z.dlg);
    z.dlg.querySelector('[data-vs-zclose]').focus({ preventScroll: true });
  }

  /* ====================================================================== gallery */
  class VsGallery extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.track = this.querySelector('.vs-gal__track');
      if (!this.track) return;
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-vs-dot]'));
      this.counter = this.querySelector('[data-vs-gcount]');
      this.prevBtn = this.querySelector('[data-vs-gprev]');
      this.nextBtn = this.querySelector('[data-vs-gnext]');
      this.onScroll = this.sync.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      var self = this;
      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(Number(d.getAttribute('data-vs-dot'))); }); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index() - 1); }
      });
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.index() - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.index() + 1); });
      var zoomBtn = this.querySelector('[data-vs-zoom]');
      if (zoomBtn) zoomBtn.addEventListener('click', function () { self.zoom(zoomBtn); });
      this.drag();
      /* PUB_SUB_EVENTS is a top-level const of constants.js: reachable by name from another script, but it is not a property of window */
      var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS; // eslint-disable-line no-undef
      if (typeof window.subscribe === 'function' && events) {
        this.unsub = window.subscribe(events.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          var id = variant && variant.featured_media && variant.featured_media.id;
          var host = self.closest('product-info');
          if (host && event.data && event.data.sectionId && event.data.sectionId !== host.dataset.section) return;
          if (id) self.goToMedia(String(id));
        });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.__ready = false;
      if (typeof this.unsub === 'function') this.unsub();
    }
    slides() { return Array.prototype.slice.call(this.track.querySelectorAll('.vs-gal__slide')); }
    index() { return Math.max(0, Math.min(this.slides().length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)))); }
    go(i) {
      var n = this.slides().length;
      i = Math.max(0, Math.min(n - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
    }
    goToMedia(id) {
      var s = this.slides();
      for (var i = 0; i < s.length; i++) { if (s[i].getAttribute('data-media-id') === id) { this.go(i); return; } }
    }
    sync() {
      var i = this.index();
      var total = this.slides().length;
      this.dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + total;
      if (this.prevBtn) this.prevBtn.disabled = i <= 0;
      if (this.nextBtn) this.nextBtn.disabled = i >= total - 1;
    }
    zoom(opener) {
      var list = this.slides().filter(function (s) { return s.hasAttribute('data-zoom'); }).map(function (s) {
        var img = s.querySelector('img');
        return { src: s.getAttribute('data-zoom'), alt: img ? img.alt : '' };
      });
      if (!list.length) return;
      openZoom(list, Math.min(this.index(), list.length - 1), opener);
    }
    drag() {
      var t = this.track; var self = this;
      var down = false; var moved = false; var sx = 0; var sl = 0;
      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = t.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; t.classList.add('is-dragging'); }
        if (moved) t.scrollLeft = sl - dx;
      });
      function end() {
        if (!down) return;
        down = false;
        if (!moved) return;
        t.classList.remove('is-dragging');
        self.go(Math.round(t.scrollLeft / Math.max(1, t.clientWidth)));
      }
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
      t.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }
  if (!customElements.get('vs-gallery')) customElements.define('vs-gallery', VsGallery);

  /* ====================================================================== offer ticker */
  class VsTicker extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.msgs = Array.prototype.slice.call(this.querySelectorAll('[data-vs-msg]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-vs-tdot]'));
      this.i = 0;
      var self = this;
      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.show(Number(d.getAttribute('data-vs-tdot'))); }); });
      this.addEventListener('mouseenter', function () { self.paused = true; });
      this.addEventListener('mouseleave', function () { self.paused = false; });
      this.addEventListener('focusin', function () { self.paused = true; });
      this.addEventListener('focusout', function () { self.paused = false; });
      this.show(0);
      if (this.msgs.length > 1 && !reduce()) {
        this.timer = window.setInterval(function () { if (!self.paused && !doc.hidden) self.show(self.i + 1); }, Number(this.getAttribute('data-delay')) || 3000);
      }
    }
    disconnectedCallback() { this.__ready = false; window.clearInterval(this.timer); }
    show(i) {
      this.i = (i + this.msgs.length) % this.msgs.length;
      var cur = this.i;
      this.msgs.forEach(function (m, n) { m.classList.toggle('is-active', n === cur); m.setAttribute('aria-hidden', n === cur ? 'false' : 'true'); });
      this.dots.forEach(function (d, n) { if (n === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
  }
  if (!customElements.get('vs-ticker')) customElements.define('vs-ticker', VsTicker);

  /* ====================================================================== sticky order bar */
  function initSticky(scope) {
    var bars = (scope || doc).querySelectorAll('[data-vs-sticky]:not([data-vs-ready])');
    Array.prototype.forEach.call(bars, function (bar) {
      bar.setAttribute('data-vs-ready', '1');
      var info = bar.closest('product-info') || doc;
      var order = info.querySelector('[data-vs-order]');
      var real = info.querySelector('[data-vs-add]');
      var btn = bar.querySelector('[data-vs-sticky-btn]');
      var label = bar.querySelector('[data-vs-sticky-label]');
      var price = bar.querySelector('[data-vs-sticky-price]');
      if (!order || !real || !btn) return;
      function mirror() {
        var l = real.querySelector('.vs-order__label') || real.querySelector('span');
        if (label && l) label.textContent = l.textContent.trim();
        btn.disabled = real.hasAttribute('disabled');
        var node = info.querySelector('.vs-order__price');
        var text = '';
        if (node && !node.querySelector('.price--sold-out')) {
          var sale = node.querySelector('.price-item--sale');
          var reg = node.querySelector('.price-item--regular');
          text = ((sale && sale.textContent.trim()) || (reg && reg.textContent.trim()) || '').replace(/\s+/g, ' ');
        }
        if (price) price.textContent = text;
      }
      mirror();
      if (window.MutationObserver) {
        var mo = new MutationObserver(mirror);
        mo.observe(order, { childList: true, subtree: true, attributes: true, characterData: true });
      }
      function setVisible(on) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) btn.removeAttribute('tabindex'); else btn.setAttribute('tabindex', '-1');
      }
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          /* the bar follows you once the real button has scrolled UP out of sight; while the button is still below the fold (a phone at the top of the page) it stays hidden */
          entries.forEach(function (e) { setVisible(!e.isIntersecting && e.boundingClientRect.top < 0); });
        }, { threshold: 0 });
        io.observe(real);
      } else setVisible(true);
    });
  }

  /* ====================================================================== story clamp and links */
  function initStory(scope) {
    var stories = (scope || doc).querySelectorAll('[data-vs-story]:not([data-vs-ready])');
    Array.prototype.forEach.call(stories, function (story) {
      story.setAttribute('data-vs-ready', '1');
      var clamp = story.querySelector('.vs-story__clamp');
      var more = story.querySelector('.vs-story__more');
      var toggle = story.querySelector('[data-vs-more]');
      if (!clamp || !toggle) return;
      function measure() {
        if (story.classList.contains('is-open')) return;
        var over = clamp.scrollHeight > clamp.clientHeight + 2;
        story.classList.toggle('is-clamped', over);
        toggle.hidden = !(over || (more && more.textContent.trim()));
      }
      measure();
      window.addEventListener('resize', measure);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      toggle.addEventListener('click', function () {
        var open = !story.classList.contains('is-open');
        story.classList.toggle('is-open', open);
        if (more) more.hidden = !open;
        toggle.textContent = open ? toggle.getAttribute('data-less') : toggle.getAttribute('data-more');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) measure();
      });
    });
  }
  doc.addEventListener('click', function (event) {
    var open = event.target.closest('[data-vs-open-acc]');
    if (open) {
      event.preventDefault();
      var kind = open.getAttribute('data-vs-open-acc');
      var acc = doc.querySelector('.vs-pdp details.vs-acc[data-vs-kind="' + kind + '"]');
      if (acc) {
        if (!acc.open) acc.querySelector('summary').click();
        acc.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' });
      }
      return;
    }
    var jump = event.target.closest('[data-vs-scroll]');
    if (jump) {
      var target = doc.getElementById(jump.getAttribute('data-vs-scroll'));
      if (target) { event.preventDefault(); target.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' }); }
    }
  });

  function init(scope) { initSticky(scope); initStory(scope); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
